import {
  AggregationTypes,
  ITtQuoteDetail,
  TtSortByOption,
} from "api/model/tt-quote-to-order";
import {
  UPDATE_QUOTE_TO_ORDER_SELECTED_ITEMS,
  ADD_QUOTE_TO_ORDER_TO_CART_BEGIN,
  ADD_QUOTE_TO_ORDER_TO_CART_FAILURE,
  ADD_QUOTE_TO_ORDER_TO_CART_SUCCESS,
  CHANGE_QUONTITY_VALUE,
  CHANGE_QUOT_TO_ORDER_DETAILS_QUONTITY,
  FETCH_QUOT_TO_ORDER_DETAILS_BEGIN,
  FETCH_QUOT_TO_ORDER_DETAILS_SUCCESS,
  DOWNLOAD_QUOTE_TO_ORDER_FAILURE,
  DOWNLOAD_QUOTE_TO_ORDER_NOT_FOUND_FAILURE,
  DOWNLOAD_QUOTE_TO_ORDER_BEGIN,
  TOGGLE_ERROR_MODAL,
  DOWNLOAD_QUOTE_TO_ORDER_SUCCESS,
  UPDATE_SORT,
  SET_AGGREGATION_ENABLED_DEFAULT_VALUE,
  SET_AGGREGATION_TYPE,
} from "../actions/ttQuoteToOrderActions";
import { IError } from "./ttQuoteToOrderReducer";

export enum TTQuotationDetailRecStatus {
  LOADING,
  LOADED,
  ERROR,
}

export interface QuotationDetailState {
  loadStatus: TTQuotationDetailRecStatus;
  quontityChanged: boolean;
  changedQuantity: { [key: number]: number };
  data: ITtQuoteDetail;
  errors: Array<IError> | IError;
  selectedItems: Array<number>;
  notFoundErrorResponse: { [key: string]: string };
  showErrorModal: boolean;
  sort: TtSortByOption;
  isAggregationEnabledDefaultValue: boolean;
  aggregationType: AggregationTypes;
}

const initial: QuotationDetailState = {
  loadStatus: TTQuotationDetailRecStatus.LOADED,
  quontityChanged: false,
  changedQuantity: {},
  data: {} as ITtQuoteDetail,
  errors: null,
  selectedItems: [],
  notFoundErrorResponse: null,
  showErrorModal: false,
  sort: TtSortByOption.Position,
  isAggregationEnabledDefaultValue: false,
  aggregationType: null,
};

export default function quotDetReducer(state = initial, action) {
  switch (action.type) {
    case FETCH_QUOT_TO_ORDER_DETAILS_BEGIN:
    case ADD_QUOTE_TO_ORDER_TO_CART_BEGIN:
    case DOWNLOAD_QUOTE_TO_ORDER_BEGIN:
      return {
        ...state,
        loadStatus: TTQuotationDetailRecStatus.LOADING,
      };
    case FETCH_QUOT_TO_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.quotationDetailResponse,
        loadStatus: TTQuotationDetailRecStatus.LOADED,
        changedQuantity: {},
      };
    case CHANGE_QUOT_TO_ORDER_DETAILS_QUONTITY:
      return {
        ...state,
        quontityChanged: action.payload.quontityChanged,
      };
    case CHANGE_QUONTITY_VALUE: {
      return {
        ...state,
        changedQuantity: {
          ...state.changedQuantity,
          [action.payload.position]: action.payload.value,
        },
      };
    }
    case ADD_QUOTE_TO_ORDER_TO_CART_SUCCESS:
    case DOWNLOAD_QUOTE_TO_ORDER_SUCCESS:
      return {
        ...state,
        loadStatus: TTQuotationDetailRecStatus.LOADED,
      };
    case ADD_QUOTE_TO_ORDER_TO_CART_FAILURE:
    case DOWNLOAD_QUOTE_TO_ORDER_FAILURE:
      return {
        ...state,
        loadStatus: TTQuotationDetailRecStatus.LOADED,
        errors: action.payload.errors,
      };
    case UPDATE_QUOTE_TO_ORDER_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: action.payload.selectedItems,
      };
    case UPDATE_SORT:
      return {
        ...state,
        sort: action.payload.sort,
      };
    case SET_AGGREGATION_ENABLED_DEFAULT_VALUE:
      return {
        ...state,
        isAggregationEnabledDefaultValue:
          action.payload.isAggregationEnabledDefaultValue,
      };
    case DOWNLOAD_QUOTE_TO_ORDER_NOT_FOUND_FAILURE:
      return {
        ...state,
        loadStatus: TTQuotationDetailRecStatus.LOADED,
        notFoundErrorResponse: action.payload.errors,
        showErrorModal: !state.showErrorModal,
      };
    case TOGGLE_ERROR_MODAL:
      return {
        ...state,
        showErrorModal: !state.showErrorModal,
      };
    case SET_AGGREGATION_TYPE:
      return {
        ...state,
        aggregationType: action.payload.aggregationType,
      };
    default:
      return state;
  }
}
